import React from 'react'

import { ISecondaryLinksRenderer } from './index'
import {
  FooterSecondaryLinkMarkdown,
  IProps as IFooterSecondaryLinkMarkdown,
} from 'marketing-site/src/mvp/library/components/FooterSecondaryLinkMarkdown'
import { FooterSecondaryLinks } from 'marketing-site/src/mvp/library/elements/FooterSecondaryLinks'
import { ISecondaryLinks } from 'marketing-site/src/library/components/Footer'

const SecondaryLinksRenderer = ({ secondaryLink }: ISecondaryLinksRenderer): React.ReactElement => {
  switch (secondaryLink.contentType) {
    case 'footerSecondaryLinkMarkdown':
      const SecondaryLinkMarkdown = secondaryLink as IFooterSecondaryLinkMarkdown
      return <FooterSecondaryLinkMarkdown {...SecondaryLinkMarkdown} />

    case 'footerLinks':
    default:
      const footerLinks = secondaryLink as ISecondaryLinks
      return <FooterSecondaryLinks {...footerLinks} />
  }
}

export default SecondaryLinksRenderer
